import { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import RoundActionIcon from "components/buttons/RoundActionIcon";
import ReviewAdPlanContainer from "./ReviewAdPlanContainer";

import returnIcon from "assets/img/icons/return-icon.svg";

const ConfirmAdPlan = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackIconWrap = styled.div``;

export default () => {
  const navigate = useNavigate();

  // set page Title
  useEffect(() => {
    document.title = "Ad Plan Subscription | Scalelup";
  }, []);

  return (
    <Layout>
      <ConfirmAdPlan>
        <Header>
          <PageTitle>Ad Plan Subscription</PageTitle>
          <BackIconWrap>
            <RoundActionIcon
              icon={returnIcon}
              iconSize="16px"
              iconAlt="Return"
              onClick={() => navigate("/advertising-plans")}
            />
          </BackIconWrap>
        </Header>
        <ReviewAdPlanContainer />
      </ConfirmAdPlan>
    </Layout>
  );
};
